
// scale down image file propertionally and get back image in Base64 format
export const toScaledBase64: (file, height) => Promise<any> =
  (file, height) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const img = new Image();
    const _URL = window.URL || window.webkitURL;
    img.onload = function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const oc = document.createElement('canvas');
      const octx = oc.getContext('2d');
      const step = 0.3;
      canvas.height = height; // destination canvas size
      canvas.width = canvas.height * img.width / img.height;

      if (img.height * step > height) { // For performance avoid unnecessary drawing
        const mul = 1 / step;
        let cur = {
          width: Math.floor(img.width * step),
          height: Math.floor(img.height * step)
        };

        oc.width = cur.width;
        oc.height = cur.height;

        octx.drawImage(img, 0, 0, cur.width, cur.height);

        while (cur.height * step > height) {
          cur = {
            width: Math.floor(cur.width * step),
            height: Math.floor(cur.height * step)
          };
          octx.drawImage(oc, 0, 0, cur.width * mul, cur.height * mul, 0, 0, cur.width, cur.height);
        }

        ctx.drawImage(oc, 0, 0, cur.width, cur.height, 0, 0, canvas.width, canvas.height);
      } else {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      }
      resolve(canvas.toDataURL());
    };
    img.src = _URL.createObjectURL(file);
    reader.onerror = (error) => reject(error);
  });
